import { ThenapService } from 'src/services/thenap.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const THENAP_NEW_CARE_SUCCESS = 'THENAP:NEW_CARE_SUCCESS'
export const THENAP_LIST_SUCCESS = 'THENAP:FIND_ALL_SUCCESS'
export const THENAP_LIST_FAILD = 'THENAP:FIND_ALL_FAILD'
export const THENAP_COUNT_ASSIGN_SUCCESS = 'THENAP:COUNT_ASSIGN_SUCCESS'
export const THENAP_COUNT_ASSIGN_FAILD = 'THENAP:COUNT_ASSIGN_FAILD'

export const THENAP_CREATE_SUCCESS = 'THENAP:CREATE_SUCCESS'
export const THENAP_CREATE_FAILD = 'THENAP:CREATE_FAILD'

export const THENAP_IMPORT_SUCCESS = 'THENAP:IMPORT_SUCCESS'
export const THENAP_SAVE_SUCCESS = 'THENAP:SAVE_SUCCESS'
export const THENAP_SAVE_FAILD = 'THENAP:SAVE_SUCCESS'

export const THENAP_DEL_SUCCESS = 'THENAP:DEL_SUCCESS'
export const THENAP_DEL_FAILD = 'THENAP:DEL_FAILD'

export const THENAP_ONE_SUCCESS = 'THENAP:FIND_ONE_SUCCESS'
export const THENAP_ONE_FAILD = 'THENAP:FIND_ONE_FAILD'

export const THENAP_HISTORY_LIST_SUCCESS = 'THENAP:HISTORY_FIND_ALL_SUCCESS'
export const THENAP_HISTORY_LIST_FAILD = 'THENAP:HISTORY_FIND_ALL_FAILD'

export const THENAP_UPDATE_FILTER = 'THENAP:UPDATE_FILTER'

export const THENAPCOMLIST_LIST_SUCCESS = 'THENAPCOMLIST:FIND_ALL_SUCCESS'
export const THENAPCOMLIST_LIST_FAILD = 'THENAPCOMLIST:FIND_ALL_FAILD'

export const ThenapAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    updateFilter,
    batTatLoaiDichVu,
    xoaMucDaChon,
    findAllByOrder,
    yeuCauChayLaiCallback,
}

function updateFilter(payload) {
    return { type: THENAP_UPDATE_FILTER, data: payload }
}

function yeuCauChayLaiCallback(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        ThenapService.yeuCauChayLaiCallback(id).then((rs) => {
            dispatch(success(rs.data));
            dispatch(ThenapAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THENAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: THENAP_CREATE_FAILD, error } }
}

function batTatLoaiDichVu(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            ThenapService.batTatLoaiDichVu(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(ThenapAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: THENAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: THENAP_CREATE_FAILD, error } }
}

function xoaMucDaChon(payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            ThenapService.xoaMucDaChon(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(ThenapAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: THENAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: THENAP_CREATE_FAILD, error } }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            ThenapService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(ThenapAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: THENAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: THENAP_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        ThenapService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THENAP_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: THENAP_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { thenap } = getState()
        dispatch(AppAction.appLoading(true));
        ThenapService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...thenap.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THENAP_LIST_SUCCESS, data } }
    function failure(error) { return { type: THENAP_LIST_FAILD, error } }
}

function findAllByOrder(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { thenap } = getState();
        const page = thenap && typeof thenap.filter !== 'undefined' && thenap.filter && typeof thenap.filter.page !== 'undefined' ? thenap.filter.page : 0;
        const limit = thenap && typeof thenap.filter !== 'undefined' && thenap.filter && typeof thenap.filter.limit !== 'undefined' ? thenap.filter.limit : 10;
        ThenapService.findAllByOrder(id, page, limit, thenap.filter).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                const oldItems = thenap.thenapcomlist_items;
                const rsDataValues = rs.data.values;

                var uniqueItems = oldItems;
                for (var i = limit * page; i < limit * page + limit; i++) {
                    if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                        uniqueItems[i] = rsDataValues[i - limit * page];
                    } else if (typeof uniqueItems[i] !== 'undefined') {
                        delete uniqueItems[i];
                    }
                }
                
                console.log({
                    items: uniqueItems,
                    total: rs.data.count
                })
                dispatch(success({
                    items: uniqueItems,
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THENAPCOMLIST_LIST_SUCCESS, data } }
    function failure(error) { return { type: THENAPCOMLIST_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { thenap } = getState();
        const page = thenap && typeof thenap.filter !== 'undefined' && thenap.filter && typeof thenap.filter.page !== 'undefined' ? thenap.filter.page : 0;
        const limit = thenap && typeof thenap.filter !== 'undefined' && thenap.filter && typeof thenap.filter.limit !== 'undefined' ? thenap.filter.limit : 10;
        
        return new Promise((resolve, reject) => {
            ThenapService.findAll(page, limit, thenap.filter).then((rs) => {
                if (page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                        tong_sai_menh_gia: rs.data.tong_sai_menh_gia,
                        tong_dung_menh_gia: rs.data.tong_dung_menh_gia,
                        tong_loi_huy: rs.data.tong_loi_huy,
                        tong_doi_soat: rs.data.tong_doi_soat,
                        tong_chua_nap: rs.data.tong_chua_nap,
                        tong_nap: rs.data.tong_nap,
                        tong_the: rs.data.tong_the,
                    }));
                } else {
                    const oldItems = thenap.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                        tong_sai_menh_gia: rs.data.tong_sai_menh_gia,
                        tong_dung_menh_gia: rs.data.tong_dung_menh_gia,
                        tong_loi_huy: rs.data.tong_loi_huy,
                        tong_doi_soat: rs.data.tong_doi_soat,
                        tong_chua_nap: rs.data.tong_chua_nap,
                        tong_nap: rs.data.tong_nap,
                        tong_the: rs.data.tong_the,
                    }));
                }

                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: THENAP_LIST_SUCCESS, data } }
    function failure(error) { return { type: THENAP_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: THENAP_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            ThenapService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(ThenapAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: THENAP_SAVE_SUCCESS, data } }
    function failure(error) { return { type: THENAP_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            ThenapService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(ThenapAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: THENAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: THENAP_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        ThenapService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(ThenapAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THENAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: THENAP_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        ThenapService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(ThenapAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THENAP_DEL_SUCCESS, data } }
    function failure(error) { return { type: THENAP_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        ThenapService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THENAP_ONE_SUCCESS, data } }
    function failure(error) { return { type: THENAP_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        ThenapService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(ThenapAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { thenap } = getState()
        dispatch(AppAction.appLoading(true));
        ThenapService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...thenap.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THENAP_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: THENAP_HISTORY_LIST_FAILD, error } }
}